<template>
  <el-dialog
    @close="closeDialog"
    :visible.sync="isShow"
    width="600px"
    class="mergeDialogClass"
    center
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    :show-close='false'
  >
    <div class="warnInfo">
        <i class="el-icon-warning" v-if="false"></i>
        <div class="warnInfos">
           所选订单含有预约发货订单，当前发货时间和消费者预约发货时间不符，请确认是否继续发货？
           订单编号：{{showopPickDateOrderList()}}
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('close')">取 消</el-button>
        <el-button type="primary" @click="copyTextFn">复制预约发货订单号</el-button>
        <el-button type="primary" @click="ignoeOpPickDateOrderFn">全部发货</el-button>
        <el-button type="primary" @click="nolmalOpPickDateOrderFn">仅发货正常订单</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { copyText } from '@/utils/util';
export default {
  props: {
    opPickDateOrderList: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isShow: this.value,
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  mounted() {
  },
  beforeDestroy () {
  },  
  methods: {
    showopPickDateOrderList(){
      let showStr = '';
      let tempStrArr =  this.opPickDateOrderList.tempStr.split(',');
      if(tempStrArr.length>5){
        showStr = tempStrArr.slice(0,5).join(',')+'...';
      }else{
        showStr = this.opPickDateOrderList.tempStr;
      }
      return showStr;
    },
    nolmalOpPickDateOrderFn(){
     
      //只发正常订单
      let tempStrArr =  this.opPickDateOrderList.tempStr.split(',');
      let orderList = this.opPickDateOrderList.orderList;
      let printDataList = this.opPickDateOrderList.printDataList;
      let onlyDelivery = this.opPickDateOrderList.onlyDelivery;

      if(printDataList.length){
        let orderListTemp = [];
        let cpCode = orderList[0].cpCode;
        if(onlyDelivery){
          tempStrArr.forEach(orderId=>{
            printDataList.forEach(item=>{
              if(orderId==item.pOrderId){
                
                orderList.forEach((innerOrder,index)=>{
                  if(innerOrder.orderId==item.orderId){
                    orderList.splice(index,1)
                  }
                })
              }
            })
          })

          this.$emit('ignoreOpPickDateOrderTable', orderList);
          this.isShow = false;      
        }else{
          tempStrArr.forEach(orderId=>{
            printDataList.forEach((orderInner,index)=>{
              if(orderInner.logisticNo === orderId){
                printDataList.splice(index,1)
              }
            })
          })  ;        
          printDataList.forEach(item => {
            let productList = item.goodsOrderList || [];
            let list = productList.map((o) => {
              return {
                mallId: item.mallId,
                mallCode: item.mallCode,
                orderId: o.orderId,
                mailNo: item.mailNo,
                cpCode: cpCode,
                userId: this.userMess.loginId
              };
            });
            orderListTemp = orderListTemp.concat(list);
          }); 
          this.$emit('ignoreOpPickDateOrder', orderListTemp);
          this.isShow = false;                   
          
        }
        
        
        // this.bus.$emit('ignoreOpPickDateOrder', orderList);
       

      }else{
        this.$message.error('暂无正常订单可进行发货！');
        this.closeDialog();
      }
    },
    ignoeOpPickDateOrderFn(){
      
      // this.bus.$emit('ignoreOpPickDateOrder', this.opPickDateOrderList.orderList);
      if(this.opPickDateOrderList.onlyDelivery){
        this.$emit('ignoreOpPickDateOrderTable', this.opPickDateOrderList.orderList);
        this.isShow = false;  
      }else{
        this.$emit('ignoreOpPickDateOrder', this.opPickDateOrderList.orderList);
        // this.closeDialog('type');   
        this.isShow = false;       
      }

    },
    copyTextFn(){
      let showStr = '';
      let tempStrArr =  this.opPickDateOrderList.tempStr.split(',');
      if(tempStrArr.length>5){
        showStr = tempStrArr.slice(0,5).join('\r\n');
      }else{
        showStr = tempStrArr.join('\r\n');
      }      
      copyText(showStr);
    },
    closeDialog(type) {
      this.isShow = false;
      this.$emit('close',type);
      
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
.mergeDialogClass {
    .el-dialog__header{
        border-bottom:0 !important;
    }
    .el-icon-warning{
        color: #e6a23c;
        font-size: 35px;
    }
    .warnInfo{
        width: 95%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .warnInfos{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            color: #333;
            margin-left: 25px;
            margin-top: 10px;
            p{
              margin: 0;
              line-height: 20px;
              font-size: 12px;
            }
        }
    }
    .redStyle{
        color: #f00;
    }
    .mb30{
      margin-bottom: 30px!important;
    }
}
</style>
